export default "__VITE_ASSET__B4uE29pg__"